module.exports = __webpack_public_path__ + "static/image/history/pc/202504_2.ver2_0_2.jpg?edb0ef2f";